import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@/utils/constants'

const EDITABLE_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT'])

function isEditableTarget(target) {
  if (!target?.tagName) return false
  if (EDITABLE_TAGS.has(target.tagName)) {
    const input = target
    if (input.tagName === 'INPUT' && ['button', 'checkbox', 'radio', 'submit', 'reset'].includes(input.type)) {
      return false
    }
    return true
  }
  return Boolean(target.isContentEditable)
}

/**
 * Raccourcis (Ctrl ou Cmd) :
 * - L → nouveau bon de livraison
 * - F → nouvelle facture
 * - D → nouveau devis
 *
 * Désactivés lorsque le focus est dans un champ éditable (saisie, textarea, select).
 */
export function useSalesDocumentShortcuts() {
  const navigate = useNavigate()

  useEffect(() => {
    const onKeyDown = (e) => {
      if (!e.ctrlKey && !e.metaKey) return
      if (e.altKey || e.shiftKey) return
      if (isEditableTarget(e.target)) return

      let path = null
      switch (e.code) {
        case 'KeyL':
          path = `${ROUTES.DELIVERY_NOTES}/new`
          break
        case 'KeyF':
          path = `${ROUTES.FACTURES}/new`
          break
        case 'KeyD':
          path = `${ROUTES.QUOTES}/new`
          break
        default:
          return
      }

      e.preventDefault()
      e.stopPropagation()
      navigate(path)
    }

    window.addEventListener('keydown', onKeyDown, { capture: true })
    return () => window.removeEventListener('keydown', onKeyDown, { capture: true })
  }, [navigate])
}
